<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="page-head">
      <div class="mains-content">
        <div class="tops-between">
          <div class="tops-title align-items">
            <p>当前位置: <span>&nbsp;上缴记录</span></p>
          </div>
        </div>
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row space-between">
              <div style="margin-right: 10px;">
                <el-date-picker
                  v-model="times"
                  type="monthrange"
                  value-format="yyyy-MM"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  @change="timeChange"
                  size="small"
                >
                </el-date-picker>
              </div>
              <div class="flex-row">
                <!-- @change="selectChange" -->
                <el-select v-model="query.payStatus" class="select" placeholder="全部类型" filterable size="small" @change="selectChange">
                  <el-option label="全部类型" value></el-option>
                  <el-option label="待支付" value="wait"></el-option>
                  <el-option label="处理中" value="processing"></el-option>
                  <el-option label="已支付" value="finish"></el-option>
                  <el-option label="已退款" value="refund"></el-option>
                  <el-option label="已取消" value="cancel"></el-option>
                </el-select>
              </div>
              <div class="flex-row">
                <!-- @change="selectChange" -->
                <el-select v-model="query.auditStatus" class="select" placeholder="全部状态" filterable size="small" @change="selectChange">
                  <el-option label="全部状态" value></el-option>
                  <el-option label="待审核" value="wait"></el-option>
                  <el-option label="通过" value="pass"></el-option>
                  <el-option label="拒绝" value="refuse"></el-option>
                  <el-option label="取消" value="cancel"></el-option>
                </el-select>
              </div>
            </div>
            
          </div>
          <el-table :data="list" max-height="500px">
            <el-table-column prop="dataMonth" label="上缴月份" width="auto">
              <template slot-scope="scope">{{ formatMonth(scope.row.dataMonth) || ''}}</template>
            </el-table-column>
            <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
            <el-table-column prop="transferSourceCn" label="来源"></el-table-column>
            <el-table-column prop="amount" width="auto" label="金额"></el-table-column>
            <el-table-column prop="oxCtime" label="创建时间" width="auto">
              <template slot-scope="scope">{{ formatDay(scope.row.oxCtime) || '' }}</template>
            </el-table-column>
            <el-table-column prop="payWayCn" width="auto" label="支付方式"></el-table-column>
            <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
              <template slot-scope="scope">
                  <el-link type="primary" @click="editPage(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="mains-bottom">
        <div class="back el-icon-back" @click="back"></div>
        <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./editSet";
export default {
  data() {
    return {
      url: this.$url.fundTransferSum.list,
      query: {
        auditStatus: "",
        payWay: '',
        beginTime: '',
        endTime: '',
        start: 0,
        size: 20
      },
      list: [],
      times: ''
    };
  },
  mixins: [minxin],
  components: { editSet },
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/manage/fundtransfer");
    },
    editPage (row) {
      if (row.id) {
        this.$refs["editSetForm"].$emit("set", row.id);
      } else {
        this.$refs["editSetForm"].$emit("set", 0);
      }
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.fundTransferSum.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    timeChange (val) {
      console.log(val)
      this.query.beginTime = val[0] + '-01';
      this.query.endTime = val[1] + '-01';
      this.totalCounts();
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}
.mains-bottom {
  .back {
    position: absolute;
    left: 26px;
  }
  width: calc(100% - 30px);
  position: absolute;
  background-color: #fff;
  height: 62px;
  margin-top: 10px;
  padding: 0 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 15px;
  box-sizing: border-box;
  .last-btn {
    margin-left: 22px;
  }
}
.mains-content {
  height: calc(100% - 72px);
  .tops-between {
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
    // border-bottom: 2px solid @borderColor;
  }
  .tops-title {
    width: 100%;
    box-sizing: border-box;

    p {
      font-size: 18px;
      font-weight: 500;
      height: 60px;
      line-height: 60px;
      span {
        color: @blue;
      }
    }
    .add-btns {
      width: 100px;
      height: 32px;
    }
  }
  .member-content-box {
    // padding: 0 25px;
    margin-top: 10px;
  }
  .member-header {
    background: #fff;
    height: 56px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid @borderColor;
    .setDate {
      margin-right: 15px;
    }
    .top-label {
      width: 90px;
    }
    /deep/ .el-select {
      width: 150px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .input-with-select {
      width: 150px;
      height: 32px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      /deep/ .el-input__clear {
        font-size: 22px;
        line-height: 32px;
      }
      /deep/ .el-input__prefix {
        color: @blue;
        font-size: 24px;
        margin-right: 10px;
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }
}

// /deep/ .el-input-group__append {
//   background-color: #409eff;
//   color: #fff;
// }
// /deep/ .input-with-select .el-input__inner {
//   height: 56px !important;
// }
// /deep/ .input-with-select {
//   font-size: 0.18rem;
// }
// .member-header {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   width: calc(100% - 60px);
//   .title-name {
//     font-size: 20px;
//     font-weight: bold;
//     color: #333;
//     margin-right: 62px;
//   }
//   .icon-search {
//     font-size: 0.3rem;
//   }
// }
// .page-head {
//   display: flex;
//   padding: 20px 30px;
//   .times {
//     align-items: center;
//     display: flex;
//   }
//   .flex-row {
//     margin-left: 10px;
//     align-items: center;
//     display: flex;
//   }
// }
// .mains {
//   .rows {
//     padding: 0 30px 30px;
//     // padding-bottom: 0;
//     .cols {
//       padding-bottom: 40px;
//       .van-text {
//         font-size: 0.18rem;
//         font-weight: 500;
//       }
//       .van-label {
//         font-size: 0.2rem;
//         color: @red;
//         margin-top: 10px;
//       }
//     }
//   }
// }
</style>

